export const games = {
    PEGAMAS: 'JPM',
    EL_EMBUDO: 'JTF'

}